import loadModuleOnElement from "../../../utils/loadModuleOnElement";

const loader = () => import("./lazyJWPlayer");
export const selector = ".rm-lazy-jwplayer-media";

export default function loadFollowButton(context) {
    loadModuleOnElement(selector, loader, context);
    return context;
}
